/**
 * Portal Fragment
 * Handles portal logs date filtering functionality
 */

import { Events } from '../../../js/utils/events.js';

let initialized = false;

// ============================================================================
// Portal Logs Handlers
// ============================================================================

const PortalLogsHandlers = {
    /**
     * Handle simple time period radio/select change
     * Enables simple select, disables date inputs, submits form
     */
    onSimpleChange(e, element) {
        const form = element.closest('form');
        if (!form) return;

        const simpleRadio = form.querySelector('#time-simple');
        const simpleSelect = form.querySelector('#simple-select');
        const startDate = form.querySelector('#start-date');
        const endDate = form.querySelector('#end-date');

        // Check the simple radio
        if (simpleRadio) simpleRadio.checked = true;

        // Enable simple select, disable date inputs
        if (simpleSelect) simpleSelect.disabled = false;
        if (startDate) startDate.disabled = true;
        if (endDate) endDate.disabled = true;

        // Submit the form
        form.requestSubmit();
    },

    /**
     * Handle custom time period radio change
     * Disables simple select, enables date inputs
     */
    onCustomRadioChange(e, element) {
        const form = element.closest('form');
        if (!form) return;

        PortalLogsHandlers.updateDateInputs(form, false);
    },

    /**
     * Handle date input focus
     * Switches to custom mode and enables date inputs
     */
    onDateInputFocus(e, element) {
        const form = element.closest('form');
        if (!form) return;

        const customRadio = form.querySelector('#time-custom');
        if (customRadio) customRadio.checked = true;

        PortalLogsHandlers.updateDateInputs(form, false);
    },

    /**
     * Handle Go button click for custom date range
     * Only switch to custom mode if explicitly clicked (not Enter key in other inputs)
     */
    onGoButtonClick(e, element) {
        // Only switch to custom mode if this was a real mouse/touch click on the button
        // When form submits via Enter key, e.detail is 0 (no click count)
        // When user clicks button, e.detail is 1 or more
        if (e.detail > 0) {
            const form = element.closest('form');
            if (!form) return;

            const customRadio = form.querySelector('#time-custom');
            if (customRadio) customRadio.checked = true;
        }
    },

    /**
     * Update date inputs enabled/disabled state
     * @param {HTMLElement} form - The form element
     * @param {boolean} disabled - Whether to disable date inputs (and enable simple)
     */
    updateDateInputs(form, disabled) {
        const simpleSelect = form.querySelector('#simple-select');
        const startDate = form.querySelector('#start-date');
        const endDate = form.querySelector('#end-date');

        if (disabled) {
            // Simple mode: enable simple, disable dates
            if (simpleSelect) simpleSelect.disabled = false;
            if (startDate) startDate.disabled = true;
            if (endDate) endDate.disabled = true;
        } else {
            // Custom mode: disable simple, enable dates
            if (simpleSelect) simpleSelect.disabled = true;
            if (startDate) startDate.disabled = false;
            if (endDate) endDate.disabled = false;
        }
    }
};

// ============================================================================
// Initialization
// ============================================================================

export function initPortal() {
    if (initialized) return;
    initialized = true;

    // Simple time period radio change
    Events.on('change', 'portal-logs-simple-radio', PortalLogsHandlers.onSimpleChange);

    // Simple select change (also triggers simple mode)
    Events.on('change', 'portal-logs-simple-select', PortalLogsHandlers.onSimpleChange);

    // Custom time period radio change
    Events.on('change', 'portal-logs-custom-radio', PortalLogsHandlers.onCustomRadioChange);

    // Date input focus (switches to custom mode)
    Events.on('focus', 'portal-logs-date-input', PortalLogsHandlers.onDateInputFocus);

    // Go button click (ensures custom radio is checked)
    Events.on('click', 'portal-logs-go-button', PortalLogsHandlers.onGoButtonClick);

    console.log('[LeapFILE] Portal fragment initialized');
}
